import { makeStyles } from "@material-ui/core";
import React from "react";

interface SplitedTabLayoutProps {
  children: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: "100%",
    overflow: "hidden",
    width: "100%",
    flexGrow: 1,
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    padding: 0,
  },
}));

export const SplitedTabLayout = (
  props: SplitedTabLayoutProps,
  ...rest: any[]
) => {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      className={classes.root}
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className={classes.wrapper}>{props.children}</div>
      )}
    </div>
  );
};
